import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
const CartCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    if (!localStorage.getItem("hawk_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("hawk_token"); setUser(false); });
  }, []);

  const value = useMemo(() => ({
    user,
    setUser,
    login: async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); localStorage.setItem("hawk_token", data.token); setUser(data.user); return data.user; },
    register: async (body) => { const { data } = await api.post("/auth/register", body); localStorage.setItem("hawk_token", data.token); setUser(data.user); return data.user; },
    logout: () => { localStorage.removeItem("hawk_token"); setUser(false); },
  }), [user]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
export const useAuth = () => useContext(AuthCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem("hawk_cart") || "[]"); } catch { return []; } });
  const [coupon, setCoupon] = useState(() => localStorage.getItem("hawk_coupon") || "");
  useEffect(() => localStorage.setItem("hawk_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("hawk_coupon", coupon), [coupon]);

  const add = useCallback((product, qty = 1) => setItems((cur) => {
    const i = cur.findIndex((x) => x.product_id === product.id);
    if (i >= 0) { const next = [...cur]; next[i] = { ...next[i], quantity: Math.min(99, next[i].quantity + qty) }; return next; }
    return [...cur, { product_id: product.id, slug: product.slug, name: product.name, image: product.image, price: product.final_price, quantity: qty }];
  }), []);
  const update = useCallback((product_id, quantity) => setItems((cur) => quantity <= 0 ? cur.filter((x) => x.product_id !== product_id) : cur.map((x) => x.product_id === product_id ? { ...x, quantity } : x)), []);
  const remove = useCallback((product_id) => setItems((cur) => cur.filter((x) => x.product_id !== product_id)), []);
  const clear = useCallback(() => { setItems([]); setCoupon(""); }, []);
  const count = items.reduce((n, i) => n + i.quantity, 0);
  const value = useMemo(() => ({ items, count, coupon, setCoupon, add, update, remove, clear }), [items, count, coupon, add, update, remove, clear]);
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}
export const useCart = () => useContext(CartCtx);
